import { render, staticRenderFns } from "./menuaddorupdate.vue?vue&type=template&id=992662ec"
import script from "./menuaddorupdate.vue?vue&type=script&lang=js"
export * from "./menuaddorupdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports